import { isApiErrorDto } from "../../../../common/errors/isApiErrorDto";

interface RtkLikeError {
  status?: number | string;
  data?: unknown;
}

interface SaveWithVersionConflictRetryParams<TFields, TResult> {
  fields: Partial<TFields>;
  save: (fields: Partial<TFields>) => Promise<TResult>;
  reloadLatest: () => Promise<unknown>;
}

export async function saveWithVersionConflictRetry<TFields, TResult>({
  fields,
  save,
  reloadLatest,
}: SaveWithVersionConflictRetryParams<TFields, TResult>): Promise<TResult> {
  try {
    return await save(fields);
  } catch (error) {
    if (!isVersionConflictError(error)) throw error;
    await reloadLatest();
    return await save(fields);
  }
}

export async function retryOnVersionConflict<TResult>(action: () => Promise<TResult>): Promise<TResult> {
  try {
    return await action();
  } catch (error) {
    if (!isVersionConflictError(error)) throw error;
    return await action();
  }
}

export function isVersionConflictError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const rtkError = error as RtkLikeError;
  return rtkError.status === 409 && isApiErrorDto(rtkError.data) && rtkError.data.errorCode === "VERSION_CONFLICT";
}
